<script>
export default {
  data() {
    return {
      toggleHamburguer: false,
    };
  },
};
</script>

<template>
  <div
    @click="
      (toggleHamburguer = !toggleHamburguer),
        $emit('hamburguerState', toggleHamburguer)
    "
    :class="{ open: toggleHamburguer }"
    class="menuHamburguer"
    for="check"
  >
    <input type="checkbox" id="check" />
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<style scoped>
div.menuHamburguer {
  display: flex;
  flex-direction: column;
  width: 40px;
  cursor: pointer;
  opacity: 50%;
  transition: var(--slow-med);
  z-index: 40;
  z-index: 101;
  margin-right: 0.5rem;
  opacity: 100%;
}

.open.menuHamburguer {
  right: 30px;
  top: 40px;
}

div.menuHamburguer:hover {
  opacity: 60%;
}

div.menuHamburguer span {
  background: #fff;
  border-radius: 10px;
  height: 2px;
  margin: 3px 0;
  transition: 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
  width: calc(100% - 10px);
  max-width: 40px;
  position: relative;
  left: 20px;
}

.open.menuHamburguer span {
  background: #fff;
}

.open input[type="checkbox"] span {
  width: 100%;
}

div.menuHamburguer span::after {
  background: #06d6c6;
  border-radius: 10px;
  height: 7px;
  transition: 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
  width: 100%;
}

span:nth-of-type(2) {
  width: 100%;
}

input[type="checkbox"] {
  display: none;
}

.open input[type="checkbox"] ~ span {
  width: 50%;
}

.open input[type="checkbox"] ~ span:nth-of-type(1) {
  transform-origin: bottom;
}

input[type="checkbox"] ~ span:nth-of-type(1)::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: bottom;
  right: 0px;
  opacity: 0%;
}

.open input[type="checkbox"] ~ span:nth-of-type(1)::after {
  content: "";
  width: 65%;
  transform: rotatez(-40deg) translate(5px, 9px);
  opacity: 100%;
}

.open input[type="checkbox"] ~ span:nth-of-type(2) {
  transform-origin: top;
  width: 35%;
}

input[type="checkbox"] ~ span:nth-of-type(3):after {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  transform-origin: bottom;
  right: 0px;
  opacity: 0%;
}

input[type="checkbox"] ~ span:nth-of-type(3) {
  transform-origin: bottom;
}

.open input[type="checkbox"] ~ span:nth-of-type(3):after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: bottom;
  width: 65%;
  transform: translate(8px, -5px) rotatez(40deg);
  opacity: 100%;
}
</style>